export default "__VITE_ASSET__f8b25ff9__"